import React, { useState } from "react";
import useUserProfile from "../../../../Hooks/useUserProfile";
import { Button, UploadPhoto, Toast } from "../../../../Components";
import ApprovalTasks from "./approvals";
import CoverPhoto from "./cover";
import { FiLogOut, FiSettings } from "react-icons/fi";
import BookingsCount from "./bookingsCount";
import { useNavigate } from "react-router-dom";
import { useClientSettings } from "../../../../Hooks/useClientSettings";
import AtAGlance from "./glance";
import { apis, patch } from "../../../../Utils/axios";
import { useLoginHook } from "../../../../Hooks/useLoginHook";

function Dashboard() {
	const NAVIGATE = useNavigate();
	const { logout } = useLoginHook();
	const { profile, reload } = useUserProfile();
	const { isEnabled } = useClientSettings();
	const teamsPlan = isEnabled("ORGANIZATION") && isEnabled("POLICY");
	const glanceOptions = [
		{ label: "Flights", value: "flight" },
		{ label: "Expenses", value: "expense" },
	];
	const [GlanceType, setGlanceType] = useState(glanceOptions[0]);

	const onUpdate = (obj) => {
		patch(apis.updateMyProfile, { photo: obj.file.key }, (r, e) => {
			if (r) {
				reload();
				Toast.success(`Photo updated`);
			} else if (e) {
				console.log(e);
				Toast.handleError(e);
			}
		});
	};

	return (
		<>
			<CoverPhoto />
			<div className="p-4">
				<div className="p-4 border shadow-sm rounded-2xl border-surface bg-canvas">
					<div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
						<div className="flex items-center gap-3 sm:gap-4">
							<UploadPhoto size="lg" photo={profile.photo} onUpdate={onUpdate} />
							<div className="min-w-0">
								<div className="text-xs uppercase tracking-wide text-secondary">Welcome Back</div>
								<h1 className="mt-0.5 text-xl leading-tight sm:text-2xl truncate">Hello {profile.fName},</h1>
								<div className="mt-1 text-sm text-secondary">Manage your account and review your latest travel updates.</div>
							</div>
						</div>
						<div className="grid w-full grid-cols-2 gap-2 sm:flex sm:w-auto">
							<Button onClick={() => NAVIGATE("/app/account")} variant="outlined" className="btn-sm w-full sm:w-auto">
								<FiSettings className="mr-2" />
								Profile
							</Button>
							<Button onClick={logout} variant="light" className="btn-sm w-full sm:w-auto">
								<FiLogOut className="mr-2" />
								Sign Out
							</Button>
						</div>
					</div>
				</div>
				{teamsPlan ? (
					<>
						<AtAGlance type={GlanceType.value} options={glanceOptions} selected={GlanceType} onTypeChange={setGlanceType} />
						<ApprovalTasks type={GlanceType.value} />
					</>
				) : (
					<BookingsCount />
				)}
			</div>
		</>
	);
}

export default Dashboard;
